module.exports = __webpack_public_path__ + "img/T6-D-rc_3.524d2e42.png";